module.exports = __webpack_public_path__ + "assets/img/box1-4.16c75420.svg";